<div class="modal-container-content">
  <div>
    Je staat op het punt om {{ product.specs.title }} op te zeggen. Je kunt er nog gebruik van maken tot en met
    {{ (product.date_expiry || now ) | date: 'dd-MM-yyyy' }}. Weet je zeker dat je {{ product.specs.title }} op wilt zeggen?
  </div>
</div>
<div class="modal-container-footer">
  <app-button (click)="terminate()" type="primary">Ja, opzeggen</app-button>
  <app-button (click)="modalRef.cancel()" onkeyup="modalRef.cancel()" type="outline">Annuleren</app-button>
</div>
